import React from 'react';
import styled from 'styled-components';

const HudGrid = styled.svg`
  position: absolute;
  top: 0; 
  left: 0; 
  width: 100%; 
  height: 100%;
  pointer-events: none;
  z-index: 3;
  opacity: 0.3;
`;

interface AnimatedBackgroundProps {
  className?: string;
}

const AnimatedBackground: React.FC<AnimatedBackgroundProps> = ({ className }) => {
  return (
    <HudGrid className={className} viewBox="0 0 800 600" preserveAspectRatio="xMidYMid slice">
      <defs>
        <pattern id="grid" width="50" height="50" patternUnits="userSpaceOnUse">
          <path d="M 50 0 L 0 0 0 50" fill="none" stroke="rgba(0, 212, 255, 0.1)" strokeWidth="1"/>
        </pattern>
        <linearGradient id="gridGradient" x1="0%" y1="0%" x2="100%" y2="100%">
          <stop offset="0%" stopColor="#00d4ff" stopOpacity="0.4"/>
          <stop offset="50%" stopColor="#66e0ff" stopOpacity="0.2"/>
          <stop offset="100%" stopColor="#00d4ff" stopOpacity="0.1"/>
        </linearGradient>
        <radialGradient id="scanline" cx="50%" cy="50%" r="50%">
          <stop offset="0%" stopColor="#00d4ff" stopOpacity="0.8"/>
          <stop offset="70%" stopColor="#00d4ff" stopOpacity="0.3"/>
          <stop offset="100%" stopColor="#00d4ff" stopOpacity="0"/>
        </radialGradient>
      </defs>
      <rect width="800" height="600" fill="url(#grid)" />
      <g opacity="0.8">
        <path d="M0,0 L800,0 L800,600 L0,600 Z" fill="none" stroke="url(#gridGradient)" strokeWidth="0.5"/>
        
        {/* Centered animated circles */}
        <circle cx="400" cy="300" r="250" fill="none" stroke="url(#gridGradient)" strokeWidth="1">
          <animate attributeName="r" values="250;251;252;253;254;255;256;257;258;259;260;259;258;257;256;255;254;253;252;251;250" dur="8s" repeatCount="indefinite" calcMode="linear" keyTimes="0;0.05;0.1;0.15;0.2;0.25;0.3;0.35;0.4;0.45;0.5;0.55;0.6;0.65;0.7;0.75;0.8;0.85;0.9;0.95;1"/>
        </circle>
        <circle cx="400" cy="300" r="200" fill="none" stroke="url(#gridGradient)" strokeWidth="1">
          <animate attributeName="r" values="200;201;202;203;204;205;206;207;208;209;210;209;208;207;206;205;204;203;202;201;200" dur="8s" repeatCount="indefinite" calcMode="linear" keyTimes="0;0.05;0.1;0.15;0.2;0.25;0.3;0.35;0.4;0.45;0.5;0.55;0.6;0.65;0.7;0.75;0.8;0.85;0.9;0.95;1"/>
        </circle>
        <circle cx="400" cy="300" r="150" fill="none" stroke="url(#gridGradient)" strokeWidth="1">
          <animate attributeName="r" values="150;151;152;153;154;155;156;157;158;159;160;159;158;157;156;155;154;153;152;151;150" dur="8s" repeatCount="indefinite" calcMode="linear" keyTimes="0;0.05;0.1;0.15;0.2;0.25;0.3;0.35;0.4;0.45;0.5;0.55;0.6;0.65;0.7;0.75;0.8;0.85;0.9;0.95;1"/>
        </circle>
        
      </g>
    </HudGrid>
  );
};

export default AnimatedBackground;
